import { useEffect, useState } from 'react';

// Calls /api/pricing/resolve to get the layered breakdown for the current
// user. Re-runs when product or qty changes. Returns null until first load
// and on errors.

const tokenHdr = () => {
  const t = localStorage.getItem('token') || localStorage.getItem('authToken');
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export default function useResolvedPrice(productId, qty = 1, couponCode = null) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!productId) return;
    let alive = true;
    const params = new URLSearchParams({ product_id: productId, qty: String(qty || 1) });
    if (couponCode) params.set('coupon', couponCode);
    fetch(`/api/pricing/resolve?${params}`, { headers: tokenHdr() })
      .then(r => r.ok ? r.json() : null)
      .then(j => { if (alive) setData(j || null); })
      .catch(() => {});
    return () => { alive = false; };
  }, [productId, qty, couponCode]);
  return data;
}
